// Shared frame for the email sign-in screens. Styling uses the app's
// existing Tailwind + <Button> components (a redesign is planned).
import React from 'react';
import { Link } from 'react-router-dom';

export function AuthShell({ children, aside }) {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <header className="px-6 py-4">
        <Link to="/" className="text-xl font-bold tracking-tight text-gray-900">flowize</Link>
      </header>
      <div className="flex-1 flex flex-col items-center px-4 pb-16 pt-6 gap-6">
        <main className="w-full max-w-md bg-white rounded-xl shadow-sm border border-gray-200 p-8">
          {children}
        </main>
        {aside && (
          <aside className="w-full max-w-md text-sm text-gray-600 bg-white/60 border border-dashed border-gray-300 rounded-xl p-4">
            {aside}
          </aside>
        )}
      </div>
    </div>
  );
}

export function FormMsg({ children, error }) {
  return (
    <p role="status" className={`min-h-[1.25rem] text-sm mt-3 ${error ? 'text-red-600' : 'text-gray-600'}`}>
      {children}
    </p>
  );
}

export const EMAIL_RE = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;

export function maskEmail(email) {
  const i = email.lastIndexOf('@');
  if (i < 1) return '';
  return `${email.charAt(0)}***${email.slice(i)}`;
}

export const inputClass =
  'w-full h-10 px-3 rounded-lg border border-gray-300 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500';
